<template>
  <div>
    <NavbarPublic v-if="userAgent.screenType == 'large'" />

    <div class="page-wrapper full-page">
      <div
        class="page-content d-flex align-items-center justify-content-center"
      >
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </div>
</template>

<script>
import NavbarPublic from "@/components/public/NavbarPublic.vue";

export default {
  components: {
    NavbarPublic,
  },
  data() {
    return {
      userAgent: {},
    };
  },

  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.userAgent = this.$root.getUserAgentDetails();
    },
  },

  mounted() {
    this.handleResize();
  },
};
</script>

<style scoped>
.page-wrapper {
  margin-top: 72px;
}
@media (max-width: 768px) {
  .page-wrapper {
    margin-top: 0px;
  }
}
</style>